<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    Edit Form Field Names
</h1>

<form>
    <!-- Content. -->
    <div mat-dialog-content>
        <kendo-grid [kendoGridBinding]="this.AllFormFields"
                    class="field-names-kendo-grid">
            <kendo-grid-column field="field_name" title="Field Name" [width]="30">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <input matInput
                           type="text"
                           [formControl]="dataItem.NameFormControl"
                           placeholder="Enter a field name"
                           name="field-name"
                           class="field-name-mat-input" />
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="field_display_name" title="Field Display Name" [width]="30">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <input matInput
                           type="text"
                           [formControl]="dataItem.DisplayNameFormControl"
                           placeholder="Enter a field display name"
                           name="field-display-name"
                           class="field-display-name-mat-input" />
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="field_type" title="Field Type" [width]="30">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{this.getFieldTypeName(dataItem.formField)}}</span>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>

    <div>
        <span class="error-message-span">{{this.ReasonSaveButtonDisabled}}</span>
    </div>

    <!-- Action buttons. -->
    <div mat-dialog-actions>
        <button mat-flat-button
                type="submit"
                color="primary"
                class="theme-primary-btn"
                [disabled]="this.SaveButtonDisabled"
                (click)="this.saveClicked()">
            Save
        </button>

        <button mat-stroked-button
                [disabled]="false"
                [mat-dialog-close]="null"
                color="basic"
                style="margin-left: 10px;"
                click="this.cancelClicked()">
            Cancel
        </button>
    </div>

</form>
